// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"style_tabsContainer__PdmT4","tabsList":"style_tabsList__LOy97","center":"style_center__esWjZ","skeleton":"style_skeleton__6Qddz"};